import { NgModule } from '@angular/core';

import { SafeHTMLPipe } from './save-html';
@NgModule({
  imports: [],
  declarations: [SafeHTMLPipe],
  exports: [SafeHTMLPipe]
})
export class NgZorroAntdMobilePipesModule {}
